<script setup lang="ts">
import { defineProps } from "vue";

const props = defineProps<{
  tagName: string;
  bgImage: string;
}>();
</script>

<template>
  <!--   backdrop-blur-[30px] bg-[#D39F471F] -->
  <div
    class="xl:h-8 md:h-[25px] min-h-[17px] text-left content-center rounded-[4px] md:rounded-lg bg-[#D39F47FF] text-white sf-pro font-semibold text-[11px] leading-100p md:text-sm md:leading-[21px] xl:text-base xl:leading-[28px] px-1 md:px-2 py-0.5"
  >
    {{ props.tagName }}
  </div>

  <!--  <div-->
  <!--    class="relative h-8 w-20 rounded-lg overflow-hidden inline-flex items-center"-->
  <!--  >-->
  <!--    &lt;!&ndash; Фон с блюром &ndash;&gt;-->
  <!--    <img-->
  <!--      :src="props.bgImage"-->
  <!--      alt="blog image"-->
  <!--      class="absolute bottom-0 left-0"-->
  <!--      style="width: 396px; height: 290px; object-fit: cover; filter: blur(20px)"-->
  <!--    />-->

  <!--    &lt;!&ndash; Текст &ndash;&gt;-->
  <!--    <span-->
  <!--      class="text-white z-10 sf-pro-sm font-semibold px-2 py-[2px] bg-[#D39F471A] w-full h-full"-->
  <!--    ></span>-->
  <!--  </div>-->
</template>
